<template>
  <v-sheet class="apexChartWrapper" :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'">
    <div id="chart-wrap">
      <!-- Chart container -->
      <div ref="chart" id="chart"></div>

      <!-- Custom legend -->
      <!-- <div class="legend">
        <div class="pretty p-svg p-smooth" v-for="item in legendItems" :key="item.name">
          <input type="checkbox" @change="toggleSeries(item.name)" />
          <div class="state" :class="item.stateClass">
            <label>{{ item.label }}</label>
          </div>
        </div>
      </div> -->
    </div>
  </v-sheet>
</template>

<script>
import ApexCharts from "apexcharts";
import moment from "moment";
import { mapActions, mapState } from "vuex";

export default {
  name: "ChartWithLegend",
  data() {
    return {
      chart: null,
      seriesOptions: [], // will be filled dynamically
      options: {
        legend: {
          position: "top",
          horizontalAlign: "left",
          markers: {
            width: 12,
            height: 12,
            radius: 6,
            offsetX: -4,
            offsetY: 0,
          },
        }, 
        chart: {
          height: 180,
          type: "line",
          stacked: false,
          toolbar: { show: false },
        },
        stroke: {
          width: 5,
          curve: "smooth",
          colors: ["rgb(3, 157, 233)"],
        },
        plotOptions: {
          bar: { columnWidth: "50%" },
        },
        grid: {
          show: false,
        },
        fill: {
          opacity: 1,
          gradient: {
            inverseColors: false,
            shade: "light",
            type: "vertical",
            opacityFrom: 0.85,
            opacityTo: 0.55,
            stops: [0, 100, 100, 100],
          },
        },
        labels: [],
        markers: { size: 0 },
        xaxis: {
          type: "category",
          axisBorder: { show: false },
        },
        yaxis: {
          title: { text: "Profit/Loss" },
          min: undefined,
          axisBorder: { show: false },
        },
        tooltip: {
          shared: true,
          intersect: false,
          y: {
            formatter: (y) => (y !== undefined ? `$${y.toFixed(2)}` : y),
          },
        },
      },
      // legendItems: [
      //   { name: "Line", label: "Profit/Loss", stateClass: "success" },
      // ],
    };
  },
  computed: {
    ...mapState("account", ["profit_loss"]),
  },
  async mounted() {
    await this.PROFITLOSS();
    this.prepareChartData();
  },
  methods: {
    ...mapActions("account", ["PROFITLOSS"]),
    prepareChartData() {
      if (!this.profit_loss?.data) return;

      const labels = this.profit_loss.data.map((item) =>
        moment(`${item.year}-${item.month}`, "YYYY-M").format("MMM YYYY")
      );

      const dataSeries = this.profit_loss.data.map((item) =>
        parseFloat(item.total_profit)
      );

      this.seriesOptions = [
        {
          name: "Profit/Loss",
          type: "line",
          data: dataSeries,
        },
      ];

      this.options.labels = labels;
      this.options.series = [this.seriesOptions[0]];

      this.chart = new ApexCharts(this.$refs.chart, this.options);
      this.chart.render();
    },
    toggleSeries(name) {
      const seriesObj = this.seriesOptions.find((s) => s.name === name);
      this.chart.updateOptions({ chart: { type: seriesObj.type } }, false);
      this.chart.updateSeries([seriesObj], true);
    },
  },
};
</script>
